<template lang="pug">
mini-shop
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import registerServices from '@/services'

import MiniShop from '@/pages/MiniShop'

// IMPORTANT: register services outside of component, immediately after import of store
// Otherwise the components do not have the state.orderFormService defined and will error it
registerServices(store)

// Embedding pages (Neos/Shopify) used to inject `window.miniShopName` before
// bootstrap; iframe embeds can't reach into a cross-origin frame, so we also
// accept `?shopName=` on the URL. window wins if both are set.
function resolveMiniShopName () {
  if (window.miniShopName) return window.miniShopName
  try {
    return new URLSearchParams(window.location.search).get('shopName') || undefined
  } catch (e) {
    return undefined
  }
}
Vue.prototype.$miniShopName = resolveMiniShopName()

export default {
  name: 'MiniShopContainer',
  store: store,
  components: {
    MiniShop
  }
}
</script>
